import EntityManager from "@/components/EntityManager";
import { toast } from "sonner";

function toastRelink(saved) {
  const r = saved?.relink;
  if (!r) return;
  const maps = (r.filtered_maps || 0) + (r.raw_maps || 0);
  if (maps || r.cases) {
    toast.info(`${maps} mapa(s) e ${r.cases || 0} caso(s) já existentes foram vinculados a este hospital — Produção/Financeiro atualizados.`);
  }
}

export default function HospitalsPage() {
  return (
    <EntityManager
      testidPrefix="hospitals"
      onSaved={toastRelink}
      title="Hospitais"
      description="Hospitais onde são realizadas as cirurgias. Os campos de custo de instrumentador são opcionais — se ficarem em branco, o sistema usa o padrão global das Configurações."
      endpoint="/hospitals"
      primaryField="name"
      columns={[
        { key: "name", label: "Nome" },
        { key: "short_name", label: "Sigla" },
        { key: "name_aliases", label: "Outros nomes", render: (s) => (s.name_aliases || []).join(", ") || "—" },
        { key: "cnes", label: "CNES" },
        { key: "municipality", label: "Município" },
        { key: "active", label: "Ativo?", render: (s) => s.active ? "Sim" : "Não" },
      ]}
      fields={[
        { name: "name", label: "Nome do hospital", required: true, fullWidth: true },
        { name: "short_name", label: "Sigla / nome curto (ex.: HGR)" },
        { name: "name_aliases", label: "Outros nomes usados nos mapas (separe por vírgula)" },
        { name: "cnes", label: "CNES" },
        { name: "municipality", label: "Município" },
        { name: "active", label: "Ativo", type: "checkbox", default: true, checkboxLabel: "Ativo" },
        { name: "notes", label: "Observações", type: "textarea", fullWidth: true },
        { name: "tech_cost_per_day", label: "💡 Custo instrum. — MODO DIÁRIA (R$ por dia com cirurgia) — vazio = usa modelo por turno", type: "number", fullWidth: true },
        { name: "tech_cost_manha", label: "Custo instrum. — Manhã (seg-sex) — R$ (vazio = padrão global)", type: "number" },
        { name: "tech_cost_tarde", label: "Custo instrum. — Tarde (seg-sex) — R$", type: "number" },
        { name: "tech_cost_noite", label: "Custo instrum. — Noite (seg-sex) — R$", type: "number" },
        { name: "tech_cost_dia_fds", label: "Custo instrum. — Dia (sáb/dom) — R$", type: "number" },
        { name: "tech_cost_noite_fds", label: "Custo instrum. — Noite (sáb/dom) — R$", type: "number" },
      ]}
    />
  );
}
